/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";

import type Patient from "parog-web/models/patient";
import type SemeiaSessionService from "parog-web/services/session";
import { sortBy } from "parog-web/utils/sort";

interface Signature {
  Args: {
    patient: Patient;
    je: BioExamResultsReceivedJournalEvent;
  };
}

export default class HlaConsultFormComponent extends Component<Signature> {
  @service declare store: Store;
  @service declare session: SemeiaSessionService;

  get bioExamJes() {
    return this.args.patient.bioExamResultsReceivedJournalEvents;
  }

  get hlaRelatedJes() {
    return this.bioExamJes.filter(je => Boolean(je.hlaId));
  }

  get sortedHlaRelatedJes() {
    return this.hlaRelatedJes.sort(sortBy("occurredAt", "desc"));
  }

  get hlaRoute(): string {
    return this.session.patient
      ? "patient-web.protected.hla.consult"
      : "medics-web.protected.patients.patient.hla.consult";
  }
}
